import React, { useState } from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import RTGSTransactionsTable from '../components/RTGSTransactionsTable';
interface RTGSTransactionsProps {
  onLogout: () => void;
}
const RTGSTransactions: React.FC<RTGSTransactionsProps> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC',
    overflow: 'hidden'
  }} data-id="element-4388" data-mp="1su2ndde51hb2">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} title="RTGS Transactions" data-id="element-4389" data-mp="1ivd2rcuuxir4" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="rtgs" data-id="element-4390" data-mp="1nv993ir11m9u" />
      <Box component="main" sx={{
      flexGrow: 1,
      p: 2,
      width: {
        xs: '100%',
        sm: `calc(100% - 240px)`
      },
      maxWidth: '100%',
      ml: {
        xs: 0,
        sm: '240px'
      },
      mt: 8,
      overflow: 'hidden'
    }} data-id="element-4391" data-mp="lwzqy0cczz7e">
        <Box sx={{
        maxWidth: '100%'
      }} data-id="element-4392" data-mp="35qebi7akubl">
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }} data-id="element-4393" data-mp="3ubrhz5oxgln7">
            <Icon icon="lucide:building-2" width={28} height={28} color="#8B5CF6" data-id="element-4394" data-mp="bz3g79nc369t" />
            <Typography variant="h5" component="h1" sx={{
            ml: 1.5,
            fontWeight: 600
          }} data-id="element-4395" data-mp="3flaivszrm7th">
              RTGS Transactions
            </Typography>
          </Box>
          <RTGSTransactionsTable data-id="element-4396" data-mp="1ei05ndt2gz9a" />
        </Box>
      </Box>
    </Box>;
};
export default RTGSTransactions;